var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.00195312,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#878B92"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5291 17.998H7.07558C6.92293 17.998 6.77653 17.9374 6.66858 17.8295C6.56064 17.7215 6.5 17.5751 6.5 17.4225V14.2074C6.5 14.1318 6.51489 14.0569 6.54381 13.9871C6.57274 13.9173 6.61514 13.8538 6.66858 13.8004L15.3023 5.16663C15.4103 5.05869 15.5567 4.99805 15.7093 4.99805C15.862 4.99805 16.0084 5.05869 16.1163 5.16663L19.3314 8.38172C19.4394 8.48966 19.5 8.63606 19.5 8.78871C19.5 8.94137 19.4394 9.08777 19.3314 9.19571L10.5291 17.998Z",
    stroke: "#D2D7DC",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4072 7.06152L17.4363 11.0906",
    stroke: "#D2D7DC",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1628 17.9983H10.5291L6.53662 14.0059",
    stroke: "#D2D7DC",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCommentIcon);
export default __webpack_public_path__ + "static/media/edit_comment_icon.077526d5b23250fabf54a3bd4ba2d138.svg";
export { ForwardRef as ReactComponent };